import axiosInstance from "./api_service";
import ApiRoutes from "../utils/api_routes";

export const getAllEmployees = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getAllEmployees);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ?? "Failed to fetch employees",
    );
  }
};

export const addEmployee = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addEmployee, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Failed to add employee");
  }
};

export const updateEmployee = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateEmployee, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ?? "Failed to update employee",
    );
  }
};

export const deleteEmployee = async (data) => {
  try {
    console.log(JSON.stringify(data));
    const response = await axiosInstance.post(ApiRoutes.deleteEmployee, data);
    console.log(response.data);

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ?? "Failed to delete employee",
    );
  }
};

export const updateEmployeeStatus = async (data) => {
  try {
    const response = await axiosInstance.post(
      ApiRoutes.updateEmployeeStatus,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ?? "Failed to update employee status",
    );
  }
};

export const getAdminReports = async (data) => {
  try {
    console.log(JSON.stringify(data));

    const response = await axiosInstance.post(ApiRoutes.adminAllReports, data);
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ?? "Failed to fetch reports",
    );
  }
};

export const getAllProjects = async () => {
  try {

    const response = await axiosInstance.post(ApiRoutes.projectList, {});
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ?? "Failed to fetch projects",
    );
  }
};
